import BaseCommand from "@/models/api/commands/BaseCommand";

export class ConnectWithPreviousBookingCommand extends BaseCommand {
  CommandName = "ConnectWithPreviousBooking";
  Command = null;
  constructor(sessionId: string, operationId: string) {
    super(sessionId, operationId);
  }
}
